import React, { createContext, useContext, useState } from 'react';
import { type Crop, type PixelCrop } from 'react-image-crop';

interface CropContextValue {
  crop: Crop | undefined;
  setCrop: (crop: Crop | undefined) => void;
  completedCrop: PixelCrop | undefined;
  setCompletedCrop: (crop: PixelCrop | undefined) => void;
  aspect: number | undefined;
  setAspect: (aspect: number | undefined) => void;
}

const CropContext = createContext<CropContextValue | null>(null);

export const useCrop = (): CropContextValue => {
  const ctx = useContext(CropContext);
  if (!ctx) throw new Error('useCrop must be used within a CropProvider');
  return ctx;
};

export const CropProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [aspect, setAspect] = useState<number | undefined>();

  return (
    <CropContext.Provider value={{ crop, setCrop, completedCrop, setCompletedCrop, aspect, setAspect }}>
      {children}
    </CropContext.Provider>
  );
};
